import { Link, useMatch, useResolvedPath, useNavigate, useLocation } from "react-router-dom";
import ModalLogin from "../features/auth/ModalLogin";
import dataApplicationsContext, { ROLES } from '../context/dataApplicationsContext';
import { useState, useContext, useEffect } from 'react';
import ImgPlaceholder from './ImgPlaceholder';
import { useSendLogoutMutation } from '../features/auth/authApiSlice';
import Select from 'react-select';
import secureLocalStorage from "react-secure-storage";
import Hamburger from "./Hamburger";
import { useGetAllSeasonsQuery } from "../slices/inscriptionsApiSlice";
import { useHasRole } from "../hooks/useHasRole";

export default function Navbar({ }) {
  const { 
    openModal, setOpenModal, isConnected, setIsConnected, setIsAdmin, setIsAppUser, auth, windowWidth,
    isMenuActive, setIsMenuActive, selectedSeason, setSelectedSeason
   } = useContext(dataApplicationsContext);

  const navigate = useNavigate();
  const location = useLocation();
  const { data: seasons, isLoading, isSuccess: isSuccessSeason } = useGetAllSeasonsQuery(); 
  const [sendLogout, { isLoadind, isSuccess, isError, error }] = useSendLogoutMutation();

  const [options, setOptions] = useState([]);
  const isAdmin = useHasRole(ROLES.ADMIN);

  useEffect(() => {
    if (isSuccessSeason) {
      setOptions(seasons.map(season => ({ label: season.lib_season, value: season.id_season })));
      setSelectedSeason({ label: seasons[0].lib_season, value: seasons[0].id_season })
    }
  }, [isSuccessSeason])

  const onLogoutClicked = () => {
    sendLogout();
    setIsConnected(false);
    setIsAdmin(false)
    setIsAppUser(false)
    secureLocalStorage.removeItem('offresPeriodeSelected');
    navigate('/');
  }
  
  const [locationRedirect, setlocationRedirect] = useState('/')

  const handleRedirect = (e) => {
    setlocationRedirect(e.target.attributes.href.value)
    if (window.scrollY) {
      window.scroll(0, 0);  // reset the scroll position to the top left of the document.
    }
  }

  const handleSelect = (option) => {
    setSelectedSeason(option)
  }


  if (windowWidth < 781) {
    const handleMenuActive = () => {
      setIsMenuActive(!isMenuActive);
    }

    const hamburger = 
      <div className="menu-hamburger-container" onClick={handleMenuActive}>
        <div className={`btnn ${isMenuActive ? 'active' : 'not-active'}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

    return (
      <nav className="nav">
        <div className="nav-left">
          <Link to="/" className="logo-home">
            <img src="/images/logo_cgv_blanc.svg" alt="logo-gifi" className="logo"/>
          </Link>
        </div>
        <div className="flex items-center gap-12">
          <ul className="menu-links">
            {isConnected && 
              <>
                <div className="nav-user-info nav-user-info-width ml-8">
                  <li className="username">
                    <p className="firstname text-lg">{auth.user?.first_name}</p>
                    <p className="lastname text-lg">{auth.user?.last_name}</p>
                  </li>
                </div>
              </>
            }
            {!isConnected && <i className="bi bi-person nav-people-icon" onClick={() => setOpenModal(true)}></i>}
          </ul>
          {isConnected && 
            <div className={`right-part-onSideBar ${isMenuActive ? 'active' : ''} ${windowWidth >= 1021 ? 'w-100vw' : ''}`}>
              {hamburger}
            </div>
          }
          <Hamburger />
        </div>
        {openModal && <ModalLogin locationRedirect={locationRedirect}/>}
      </nav>
    )
  }

  return  (
    <>
      <nav className="nav">
        <div className="nav-left">
          <Link to="/" className="logo-home">
            <img src="/images/logo_cgv_blanc.svg" alt="logo-gifi" className="logo"/>
            <div className="nav-title-name ml-4">
              <h1 className="nav-title-name-1">CGV</h1>
              <h1 className="nav-title-name-2">Gestion</h1>
            </div>
            <p className="nav-version ml-6 font-sans font-semibold">{process.env.REACT_APP_VERSION}</p>
          </Link>
        </div>
        <ul className="menu-links">
          {isConnected &&
            <Select
              options={options} onChange={handleSelect} value={selectedSeason} isClearable={false} 
              placeholder="Choisissez une saison"
              className="select-brief-container season" classNamePrefix={'select-brief'} isSearchable={true}
            />
          }
          {!isConnected && <li><button className="menuLink btn-login" id="login" onClick={() => setOpenModal(true)}>Se connecter</button></li>}
          {isConnected && 
            <>
              <div className="flex gap-12">
                <CustomLink to="/effectifs" end={false} onClick={handleRedirect}>Effectifs</CustomLink>
                <CustomLink to="/presence" end={false} onClick={handleRedirect}>Présences</CustomLink>
                {isAdmin && <CustomLink to="/recap" end={false} onClick={handleRedirect}>Recap'</CustomLink>}
                {isAdmin && <CustomLink to="/settings" end={false} onClick={handleRedirect}>Réglages</CustomLink>}
              </div>
              <div className="nav-user-info nav-user-info-width ml-8">
                <li className="username">
                  <p className="firstname text-lg">{auth.user?.first_name}</p>
                  <p className="lastname text-lg">{auth.user?.last_name}</p>
                </li>
                <form action="/logout" onSubmit={onLogoutClicked} className="form-logout">
                  <li><button className="menuLink btn-login" id="logout" >Se déconnecter</button></li>
                </form>
              </div>
            </>
          }
        </ul>
        
        {openModal && <ModalLogin locationRedirect={locationRedirect}/>}
      </nav>
    </>
  )
}

function CustomLink({ end, to, children, ...props}) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: {end} })
  return (
    <li className={isActive ? "link-active" : "" }>
      <Link to={to} {...props} className="menu-link">{children}</Link>
    </li>
  )
}
